<template>
	<div class="text-ternary checkoutPriceBreakdownComponent">
		<div class="flex justify-between">
			<p>{{ $t("subtotal") }}</p>
			<p class="font-serif">{{ currency.symbol }}{{ parseFloat(subtotal).toFixed(2) }}</p>
		</div>

		<div
			v-if="refundableBookingCost"
			class="flex justify-between">
			<p>{{ $t("refundableBooking") }}</p>
			<p class="font-serif">{{ currency.symbol }}{{ parseFloat(refundableBookingCost).toFixed(2) }}</p>
		</div>

		<div
			v-for="[key, value] in Object.entries(fees)"
			class="flex justify-between">
			<p>{{ key }}</p>
			<p class="font-serif">{{ currency.symbol }}{{ parseFloat(value).toFixed(2) }}</p>
		</div>

		<div
			v-if="discountedAmount"
			class="flex justify-between">
			<p>{{ $t("discounts") }}</p>
			<p class="font-serif text-primary">-{{ currency.symbol }}{{ parseFloat(discountedAmount).toFixed(2) }}</p>
		</div>

		<div
			v-if="installments && Object.values(installments).length > 1"
			class="flex justify-between text-primary">
			<p>{{ $t("total") }}</p>
			<p class="font-serif">{{ currency.symbol }}{{ parseFloat(total).toFixed(2) }}</p>
		</div>
	</div>
</template>

<script setup>
	import { useCurrencyStore } from "~/stores/CurrencyStore"
	import { storeToRefs } from "pinia"
	import { useCartStore } from "~/stores/CartStore"

	const currencyStore = useCurrencyStore()
	const { currency } = storeToRefs(currencyStore)

	const cartStore = useCartStore()
	const { subtotal, fees, total, installments, refundableBookingCost, discountedAmount } = storeToRefs(cartStore)
</script>

<style scoped></style>
